export default "__VITE_ASSET__DRkCAoWn__"